var map = {
	"./lang/sagas.js": 1556,
	"./reservation/sagas.js": 1558,
	"./resource/sagas.js": 1559
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1555;


//////////////////
// WEBPACK FOOTER
// ./src/store \.\/.+\/sagas\.js$
// module id = 1555
// module chunks = 0